/** @format */

import React from "react";
import { Link } from "react-router-dom";
import { cookieBannerMessage } from "../components/Analytics";
import { Box, Container } from "@chakra-ui/react";

// TODO - update to Chakra styling?
const OptOutPage = (props) => (
  <Box pt={"78px"}>
    <Container maxW={{ lg: "40%", md: "60%" }}>
      <div className="bk-zone bk-lg">
        <div className="bk-region">
          <div className="bk-main">
            <div className="bk-block">
              <p>
                {cookieBannerMessage}{" "}
                <Link to={"/privacy-policy#cookie-notice"} style={{textDecoration: "underline"}}>Cookie Notice</Link>
              </p>

              <p>
                To opt out of analytics cookies and the sale or sharing of any
                personal information,{" "}
                <Link
                  to={(location) => ({
                    ...location,
                    state: { showCookieConsent: true },
                  })}
                  style={{textDecoration: "underline"}}
                >
                  click here
                </Link>
                , then click the “Reject All” button.
              </p>
              <p>
                <Link to={"/"} style={{textDecoration: "underline"}}>Back to site</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  </Box>
);

export default OptOutPage;
